
import { useTranslation } from "react-i18next";

import { Text, Button } from "@fragments";

import { CommunityBanner, UserAvatar } from "@components/Community";

import './styles.scss'
import { SettingsRounded, ShareRounded } from "@mui/icons-material";

import { useCommunity } from "contexts/community";


export default function CommunityCard({ data }) {
    console.log(data)

    const { t } = useTranslation('community');

    const { community } = useCommunity();


    if (!data?.id) return null

    function handleShare() {
        window.handleOpenShareContentModal({
            title: t('communities.card.shareTitle', { name: data.name }),
            link: data.invite_url
        })
    }

    function handleConfigure(e) {
        e.stopPropagation()
        community.management.open(data)
    }

    function handleOpenCommunity() {
        community.open(data.slug)
    }

    return (
        <div className="community-card-container mb-2" onClick={handleOpenCommunity}>
            <div className="banner-container">
                {data?.hero ? <img src={data.hero} className="banner" /> : <div className="banner"></div>}
            </div>


            <div className="community-info-block">
                <div className="community-title-container mt-1 mb-1">

                    <div className="community-info-container">
                        <CommunityBanner banner={data.banner} size={48} />

                        <div>
                            <Text.h3 contrast={8} weight={500}>{data.name}</Text.h3>
                            <Text.span grow contrast={4} weight={300}>{t('communities.card.members', { value: data.members.total || 0 })}</Text.span>
                        </div>
                    </div>

                    <Button
                        variant="outlined"
                        size="small"
                        endIcon={<ShareRounded />}
                        onClick={handleShare}
                        children={t('common:actions.share')}
                        color="overlay"
                    />
                    {data.role === 'owner' &&
                        <Button
                            variant="outlined"
                            size="small"
                            icon={<SettingsRounded />}
                            onClick={handleConfigure}
                            color="overlay"
                        />
                    }

                </div>

                <div className="creators-row px-1 ml-5">
                    {
                        data.members.admins.map((admin, index) => (
                            <UserAvatar
                                key={index}
                                user={admin}
                                size={22}
                                displayName
                            />
                        ))
                    }
                </div>

            </div>
        </div>
    );
}